<template>
  <div>
    <component :is="'script'" type="application/ld+json">
      { "@context": "https://schema.org", "@type": "Article",
      "mainEntityOfPage": { "@type": "WebPage", "@id":
      "https://www.lecrandusavoir.fr/" }, "headline": "Le premier manuel
      scolaire numérique et interactif qui s'adapte aux élèves", "description":
      "L'écran du Savoir est une maison d'édition de manuels scolaires
      numériques fondée en 2021", "image":
      "https://www.lecrandusavoir.fr/img/couverture.0c9362c6.png", "author": {
      "@type": "Organization", "name": "L'écran du savoir", "url":
      "https://www.lecrandusavoir.fr/" }, "publisher": { "@type":
      "Organization", "name": "Partenaire du savoir", "logo": { "@type":
      "ImageObject", "url":
      "https://www.lecrandusavoir.fr/img/couverture.0c9362c6.png" } },
      "datePublished": "2023-02-07" }
    </component>
    <v-container class="section-header">
      <header class="header">
        <div class="header-blocs">
          <div>
            <img
              class="borders"
              :src="require('../assets/pictures/image-gauche.jpg')"
              alt="L'écran du savoir - Manuel scolaire numérique"
            />
          </div>
          <div>
            <div class="bloc-logo">
              <div class="logo">
                <img :src="require('../assets/pictures/logo.png')" />
                <h1>L'ÉCRAN DU SAVOIR</h1>
                <h2>
                  Le premier manuel scolaire numérique interactif qui s'adapte
                  aux élèves
                </h2>

                <div class="calendar">
                  <span
                    >Inscrivez-vous à nos webinaires HGEMC, allemand, italien
                    mai-juin à 18h.<br />
                    Aucune de ces dates ne vous convient ? Nous pouvons faire
                    une visio. Contactez-nous à contact@lecrandusavoir.fr</span
                  >
                  <a
                    target="_blank"
                    href="https://forms.gle/DAP82dhESwQptCZP7"
                    class="btn-link mt-2"
                    >Je m'inscris à un webinaire
                  </a>
                  <span
                    @click="scrollMeTo('manuels')"
                    class="btn-link blue-link mt-2"
                  >
                    <strong>Je découvre les spécimens numériques</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-none d-sm-flex">
            <img
              class="borders"
              :src="require('../assets/pictures/image-droite.jpg')"
              alt="L'écran du savoir - Manuel scolaire interactif"
            />
          </div>
        </div>
      </header>
    </v-container>
    <v-container fluid class="section-cards">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="cards">
              Un manuel d’histoire-géographie-EMC, d'allemand ou d'italien
              comportant des exercices interactifs et différenciés pour une
              classe participative, qui progresse quel que soit le niveau des
              élèves
            </h2>
            <div>
              <div class="cards">
                <div class="home-card">
                  <div class="card h-card">
                    <img
                      alt="Un meilleur suivi de vos élèves"
                      :src="require('../assets/pictures/picto-4.png')"
                    />
                    <h4>Des questions, des exercices interactifs...</h4>
                  </div>
                  <div class="card h-card">
                    <img
                      alt="Le manuel adapte directement les contenus à vos élèves"
                      :src="require('../assets/pictures/picto-7.png')"
                    />
                    <h4>...différenciés en trois groupes de niveaux</h4>
                  </div>
                  <div class="card h-card">
                    <img
                      alt="Envoyer des exercices du manuel à vos élèves"
                      :src="require('../assets/pictures/picto-6.png')"
                    />
                    <h4>Des contenus vidéos et audios</h4>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h2 class="cards">
              Le seul manuel interactif qui vous permet de personnaliser les
              exercices et de suivre les résultats de vos élèves
            </h2>
            <div>
              <div class="cards">
                <div class="home-card">
                  <div class="card h-card">
                    <img
                      alt="Des documents et des questions facilement modifiables"
                      :src="require('../assets/pictures/picto-2.png')"
                    />
                    <h4>
                      Modifiez facilement les questions, les textes et les cours
                    </h4>
                  </div>
                  <div class="card h-card">
                    <img
                      alt="Des contenus vidéos facilement disponibles"
                      :src="require('../assets/pictures/picto-3.png')"
                    />
                    <h4>Envoyez vos exercices du manuel à vos élèves</h4>
                  </div>

                  <div class="card h-card">
                    <img
                      alt="Des exercices et questionnaires variés"
                      :src="require('../assets/pictures/picto-1.png')"
                    />
                    <h4>
                      Suivez les résultats de vos élèves grâce au tableau de
                      bord
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid class="section-bubbles">
      <v-container>
        <v-row>
          <v-col cols="12" sm="8" class="text-left">
            <div class="video-container">
              <iframe
                src="https://www.youtube.com/embed/j6fLHkJBKPg"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </v-col>
          <v-col cols="12" sm="4" class="text-left">
            <h2 class="cards">
              Un manuel interactif qui s’adapte aux élèves et aux enseignants
            </h2>
            <h3>
              <p class="text-center text-sm-left">
                Nos manuels s’adaptent aux réponses des élèves, se modifient
                facilement et vous permettent de suivre vos élèves.
              </p>
              <p class="text-center text-sm-left">
                Découvrez nos fonctionnalités en quelques minutes.
              </p>
            </h3>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid class="section-bubbles">
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" class="text-left">
            <h2 class="cards">
              L’avis des élèves sur notre manuel d’histoire-géographie 2de
            </h2>
            <h3>
              <p class="text-center text-sm-left">
                Trois élèves ont testé notre manuel, et ont accepté de partager
                avec vous leur expérience.
              </p>
            </h3>
          </v-col>
          <v-col cols="12" sm="8" class="text-left">
            <div class="video-container">
              <iframe
                src="https://www.youtube.com/embed/5TAc5Nx6ORM"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container fluid class="section-bubbles">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="avis text-center mb-8">Avis d'enseignants</h2>
            <div class="bubbles">
              <div class="speech-bubble">
                <cite
                  >Ces versions différentes, c’est hyper intéressant, c’est un
                  des gros défis de l’enseignement, celui de s’adapter aux
                  différents niveaux.</cite
                >
                <em>Etienne, enseignant de la région Paca</em>
              </div>
              <div class="speech-bubble">
                <cite
                  >Ce manuel nous donne des évaluations régulières de nos
                  élèves, nous avons besoin de notes.</cite
                >
                <em>Pierre, enseignant de la région Grand Est </em>
              </div>
              <div class="speech-bubble">
                <cite
                  >On voit qu’ils n’avancent pas tous au même rythme, ça peut
                  éviter que certains décrochent, cette diversité il faut qu’on
                  la prenne en compte.</cite
                >
                <em>Jérôme, enseignant de la région Paca</em>
              </div>
              <div class="speech-bubble">
                <cite
                  >Le fait qu’on ait le retour des exercices dans le tableau de
                  bord, on est sûr qu’ils ont travaillé l’exercice c’est
                  bien.</cite
                >
                <em>Karine, Académie de Nancy-Metz</em>
              </div>
              <div class="speech-bubble">
                <cite>
                  Ces exercices interactifs ça m’évite de créer moi-même mes
                  supports. Ça m’intéresse, je commence toujours par un quiz. Je
                  leur dis &laquo;On va faire ce quiz-là pour mémoriser et être
                  actif&raquo;.</cite
                >
                <em>Mélanie, Académie de Versailles</em>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <v-container fluid class="section-bubbles">
      <v-container>
        <v-row>
          <v-col cols="12">
            <h2 class="avis text-center mb-8">Avis d'élèves</h2>
            <div class="bubbles">
              <div class="speech-bubble">
                <cite
                  >Les exercices apportent une autre approche qui nous aide à
                  mieux retenir les informations et les exemples.</cite
                >
                <em>Enzo, élève de seconde</em>
              </div>
              <div class="speech-bubble">
                <cite
                  >Les cours sont bien construits et faciles à comprendre.
                  »</cite
                >
                <em>Yacine, élève de seconde</em>
              </div>
              <div class="speech-bubble">
                <cite
                  >Cela nous habitue à travailler avec un ordinateur, ce qui est
                  indispensable de nos jours.</cite
                >
                <em>Emma, élève de seconde</em>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>

    <section class="le-manuel" ref="manuels">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="section-couvertures">
              <div>
                <div>
                  <img
                    alt=""
                    :src="require('../assets/pictures/EMC_H_2.png')"
                  />
                  <p class="credits">
                    Raphael, Jeune femme à la licorne, 1505-1506, Villa and
                    Galleria Borghese, Rome, Lazio, Italy, Bridgeman.
                  </p>
                </div>

                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('histoire2de', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1"
                      >mdi-open-in-new</v-icon
                    ></a
                  >
                  <h2 v-html="manualField('histoire2de', 'title')"></h2>
                  <h3>{{ manualField('histoire2de', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('histoire2de', 'price') }} <small><sup>TTC</sup></small>
                  </h4>

                  <div>
                    <a
                      target="_blank"
                      :href="manualConnectUrl('histoire2de')"
                      class="btn-link w100 mb-16 mb-sm-0"
                    >
                      <strong>{{ manualButtonLabel('histoire2de') }}</strong>
                      <span v-html="manualField('histoire2de', 'subtitle')"></span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <div>
                  <img
                    alt=""
                    :src="require('../assets/pictures/EMC_G_2.png')"
                  />
                  <p class="credits">
                    Incendie à la Teste-de-Buch juillet 2022, Abaca Press /
                    Alamy Banque D'Images
                  </p>
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('geographie2de', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1"
                      >mdi-open-in-new</v-icon
                    ></a
                  >
                  <h2 v-html="manualField('geographie2de', 'title')"></h2>
                  <h3>{{ manualField('geographie2de', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('geographie2de', 'price') }} <small><sup>TTC</sup></small>
                  </h4>

                  <div>
                    <a
                      target="_blank"
                      :href="manualConnectUrl('geographie2de')"
                      class="btn-link w100 mb-16 mb-sm-0"
                    >
                      <strong>{{ manualButtonLabel('geographie2de') }}</strong>
                      <span v-html="manualField('geographie2de', 'subtitle')"></span>
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <img alt="" :src="require('../assets/pictures/EMC_HG_2.png')" />
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('histoiregeographie2de', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1"
                      >mdi-open-in-new</v-icon
                    ></a
                  >
                  <h2 v-html="manualField('histoiregeographie2de', 'title')"></h2>
                  <h3>{{ manualField('histoiregeographie2de', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('histoiregeographie2de', 'price') }} <small><sup>TTC</sup></small>
                  </h4>

                  <div>
                    <a
                      target="_blank"
                      :href="manualConnectUrl('histoiregeographie2de')"
                      class="btn-link w100 mb-16 mb-sm-0"
                    >
                      <strong>{{ manualButtonLabel('histoiregeographie2de') }}</strong>
                      <span v-html="manualField('histoiregeographie2de', 'subtitle')"></span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="section-couvertures">
              <div>
                <div>
                  <img
                    alt=""
                    :src="require('../assets/pictures/EMC_H_1.png')"
                  />
                  <p class="credits">
                    Le Barbier, Jean-Jacques-François (dit l'Aîné), La
                    déclaration des droits de l'homme et du citoyen, Musée
                    Carnavalet, Histoire de Paris.
                  </p>
                </div>

                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('histoire1ere', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1"
                      >mdi-open-in-new</v-icon
                    ></a
                  >
                  <h2 v-html="manualField('histoire1ere', 'title')"></h2>
                  <h3>{{ manualField('histoire1ere', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('histoire1ere', 'price') }} <small><sup>TTC</sup></small>
                  </h4>

                  <a
                    target="_blank"
                    :href="manualConnectUrl('histoire1ere')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('histoire1ere') }}</strong>
                    <span v-html="manualField('histoire1ere', 'subtitle')"></span>
                  </a>
                </div>
              </div>
              <div>
                <div>
                  <img
                    alt=""
                    :src="require('../assets/pictures/EMC_G_1.png')"
                  />
                  <p class="credits">istock/photology1971</p>
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('geographie1ere', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1"
                      >mdi-open-in-new</v-icon
                    ></a
                  >
                  <h2 v-html="manualField('geographie1ere', 'title')"></h2>
                  <h3>{{ manualField('geographie1ere', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('geographie1ere', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('geographie1ere')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('geographie1ere') }}</strong>
                    <span v-html="manualField('geographie1ere', 'subtitle')"></span>
                  </a>
                </div>
              </div>
              <div>
                <img alt="" :src="require('../assets/pictures/EMC_HG_1.png')" />
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('histoiregeographie1ere', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1"
                      >mdi-open-in-new</v-icon
                    ></a
                  >
                  <h2 v-html="manualField('histoiregeographie1ere', 'title')"></h2>
                  <h3>{{ manualField('histoiregeographie1ere', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('histoiregeographie1ere', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('histoiregeographie1ere')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('histoiregeographie1ere') }}</strong>
                    <span v-html="manualField('histoiregeographie1ere', 'subtitle')"></span>
                  </a>
                </div>
              </div>
            </div>

            <div class="section-couvertures">
              <div>
                <div>
                  <img
                    alt="Couverture Histoire-géographie Terminale DNL anglais section euro"
                    :src="require('../assets/pictures/arrcouvHG-DNLTerm.png')"
                  />
                </div>
                <div class="specs">
                  <h2 v-html="manualField('histoiregeographiednlanglaisterm', 'title')"></h2>
                  <h3>{{ manualField('histoiregeographiednlanglaisterm', 'isbn') }}</h3>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('histoiregeographiednlanglaisterm')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('histoiregeographiednlanglaisterm') }}</strong>
                    <span v-html="manualField('histoiregeographiednlanglaisterm', 'subtitle')"></span>
                  </a>
                </div>
              </div>
            </div>

            <div class="text-center mt-5 mb-4">
              <p class="red--text programme">
                Mise en application du cycle terminal rentrée 2026
              </p>
            </div>

            <div class="section-couvertures">
              <div>
                <div>
                  <img
                    alt=""
                    :src="require('../assets/pictures/allemand2de.png')"
                  />
                  <p class="credits">© Kristina Kostova Dreamstime.com</p>
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('allemand2de', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1">mdi-open-in-new</v-icon></a>
                  <h2 v-html="manualField('allemand2de', 'title')"></h2>
                  <h3>{{ manualField('allemand2de', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('allemand2de', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('allemand2de')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('allemand2de') }}</strong>
                    <span v-html="manualField('allemand2de', 'subtitle')"></span>
                  </a>
                </div>
              </div>
              <div>
                <div>
                  <img
                    alt="Couverture Allemand 1ere"
                    :src="require('../assets/pictures/arrcouvAll1ere.png')"
                  />
                  <p class="credits">© Kristina Kostova Dreamstime.com</p>
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('allemand1ere', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1">mdi-open-in-new</v-icon></a>
                  <h2 v-html="manualField('allemand1ere', 'title')"></h2>
                  <h3>{{ manualField('allemand1ere', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('allemand1ere', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('allemand1ere')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('allemand1ere') }}</strong>
                    <span v-html="manualField('allemand1ere', 'subtitle')"></span>
                  </a>
                </div>
              </div>
              <div>
                <div>
                  <img
                    alt="Couverture Allemand Terminale"
                    :src="require('../assets/pictures/arrcouvAllTerm.png')"
                  />
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('allemandterm', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1">mdi-open-in-new</v-icon></a>
                  <h2 v-html="manualField('allemandterm', 'title')"></h2>
                  <h3>{{ manualField('allemandterm', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('allemandterm', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('allemandterm')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('allemandterm') }}</strong>
                    <span v-html="manualField('allemandterm', 'subtitle')"></span>
                  </a>
                </div>
              </div>
            </div>

            <div class="text-center mt-5 mb-4">
              <p class="red--text programme">
                Mise en application du cycle terminal rentrée 2026
              </p>
            </div>

            <div class="section-couvertures">
              <div>
                <div>
                  <img
                    alt=""
                    :src="require('../assets/pictures/italien2de.png')"
                  />
                  <p class="credits">© Vladimir Efimov| Dreamstime.com</p>
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('italien2de', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1">mdi-open-in-new</v-icon></a>
                  <h2 v-html="manualField('italien2de', 'title')"></h2>
                  <h3>{{ manualField('italien2de', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('italien2de', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('italien2de')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('italien2de') }}</strong>
                    <span v-html="manualField('italien2de', 'subtitle')"></span>
                  </a>
                </div>
              </div>
              <div>
                <div>
                  <img
                    alt="Couverture Italien 1ere"
                    :src="require('../assets/pictures/arrcouvItal1ere.png')"
                  />
                  <p class="credits">© Vladimir Efimov| Dreamstime.com</p>
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('italien1ere', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1">mdi-open-in-new</v-icon></a>
                  <h2 v-html="manualField('italien1ere', 'title')"></h2>
                  <h3>{{ manualField('italien1ere', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('italien1ere', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('italien1ere')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('italien1ere') }}</strong>
                    <span v-html="manualField('italien1ere', 'subtitle')"></span>
                  </a>
                </div>
              </div>
              <div>
                <div>
                  <img
                    alt="Couverture Italien Terminale"
                    :src="require('../assets/pictures/arrcouvItalTerm.png')"
                  />
                  <p class="credits">© Vladimir Efimov| Dreamstime.com</p>
                </div>
                <div class="specs">
                  <a
                    class="red--text programme"
                    :href="manualField('italienterm', 'programUrl')"
                    target="_blank"
                    >Nouveau programme 2025
                    <v-icon small color="red" class="ml-1">mdi-open-in-new</v-icon></a>
                  <h2 v-html="manualField('italienterm', 'title')"></h2>
                  <h3>{{ manualField('italienterm', 'isbn') }}</h3>
                  <h4 class="mb-6">
                    {{ manualField('italienterm', 'price') }} <small><sup>TTC</sup></small>
                  </h4>
                  <a
                    target="_blank"
                    :href="manualConnectUrl('italienterm')"
                    class="btn-link w100 mb-16 mb-sm-0"
                  >
                    <strong>{{ manualButtonLabel('italienterm') }}</strong>
                    <span v-html="manualField('italienterm', 'subtitle')"></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="offre">
              <p><strong>Offre manuel</strong></p>
              <p>Une licence offerte pour 30 manuels achetés</p>
            </div>
            <br>
            <div class="offre">
              <p><strong>Offre établissement</strong></p>
              <p>Un manuel supplémentaire offert tous les 300 manuels achetés</p>
            </div>
            <div class="centered-content">
              <h2 class="le-manuel pb-0">
                N'hésitez pas à tester gratuitement nos manuels avec vos élèves
              </h2>
            </div>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="7">
            <div class="ile-de-france">
              <img
                alt="idf"
                :src="require('../assets/pictures/ile-de-france.png')"
              />
              <p>
                Nos manuels L’Écran du Savoir sont granularisés dans Pearltrees
                et sont disponibles sur la plateforme de commande de la Région,
                Ressources.num, à destination des établissements.
              </p>
              <p>
                Découvrez votre futur manuel dans votre bibliothèque Pearltrees
                et sur
                <a href="www.lecrandusavoir.fr" target="_blank"
                  >www.lecrandusavoir.fr</a
                >
              </p>
              <!--              <p>Ces manuels vous donneront accès à nos <strong>exercices interactifs différenciés et à notre tableau de bord.</strong></p>-->
            </div>
          </v-col>
        </v-row>
      </v-container>
      <div class="centered-content subscribe-cta mt-5">
        <div class="btn-link blue-link">
          <a href="https://forms.gle/oC2APUwWRZrziRC66" target="_blank"
            >Inscrivez-vous pour :
            <ul class="text-left">
              <li>recevoir notre spécimen numérique durant 3 mois</li>
              <li>
                tester avec vos classes toutes les fonctionnalités du manuel
                d'Histoire-Géographie 2de durant trois mois (échange d’exercices
                et personnalisation)
              </li>
            </ul>
          </a>
        </div>
      </div>
    </section>

    <section class="test-manuel" ref="test-manuel">
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" class="text-center mt-sm-n16">
            <span class="step"> 1 </span>
            <a
              class="d-block white--text"
              :href="manualConnectUrl('histoire2de')"
              target="_blank"
              >Découvrez notre manuel
              <v-icon color="white" class="ml-1">mdi-open-in-new</v-icon>
            </a>
          </v-col>
          <v-col cols="12" sm="4" class="text-center mt-sm-n16">
            <div class="step">2</div>
            <p>Testez sur une ou plusieurs séances</p>
          </v-col>
          <v-col cols="12" sm="4" class="text-center mt-sm-n16">
            <div class="step">3</div>
            <p>Commandez pour la rentrée prochaine</p>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-container class="logos">
      <v-row>
        <v-col cols="12">
          <h2 class="text-center mt-5 mb-2">
            Commandez notre manuel auprès de votre libraire pour une ou
            plusieurs classes !
            <br />
            Avec le numérique chaque enseignant peut enfin choisir son manuel.
          </h2>
          <div class="logos-haut">
            <a target="_blank" href="https://www.arbs.com/">
              <img
                alt="Arbs"
                :src="require('../assets/pictures/Arbs_Logo.png')"
              />
            </a>
            <a
              target="_blank"
              href="https://catalogue.tabuleo.com/?publishers=ECRAN+DU+SAVOIR"
            >
              <img
                alt="Tabuleo"
                :src="require('../assets/pictures/logo-tabuleo.png')"
              />
            </a>

            <a target="_blank" href="https://www.emls.fr/#">
              <img
                alt="Libraire EMLS"
                :src="require('../assets/pictures/logo-emls.png')"
              />
            </a>
            <a target="_blank" href="https://www.lde.fr/">
              <img
                alt="Libraire LDE"
                :src="require('../assets/pictures/logo-lde.png')"
              />
            </a>
            <a target="_blank" href="https://gar.education.fr/">
              <img
                alt="GAR : Gestionnaire d'accès aux ressources numériques"
                :src="require('../assets/pictures/logo-gar.png')"
              />
            </a>
          </div>
          <p class="text-center mt-4">
            Vous n'avez pas de libraire ? Vous pouvez commander le manuel
            numérique directement auprès de nous, en nous adressant votre demande
            à <a href="mailto:contact@lecrandusavoir.fr">contact@lecrandusavoir.fr</a>.
            (Nous ne vendons pas de licence de manuel élève à l'unité, nous vous
            indiquerons le minimum d'achat.)
          </p>
        </v-col>
      </v-row>
      <modal-newsletter
        :dialog_newsletter="dialog_newsletter"
        @closeModalNewsletter="closeModalNewsletter"
      ></modal-newsletter>
    </v-container>
  </div>
</template>

<script>
import ModalNewsletter from "../components/ModalNewsletter.vue";
import { apiClient, apiHost } from "../api/config";

const MANUAL_DEFAULTS = {
  histoire2de: {
    status: 'PUBLIC',
    title: 'Histoire-EMC 2<sup>de</sup>',
    subtitle: 'Histoire 2de',
    isbn: '9782958353902',
    price: '8,50€',
    programUrl: 'https://eduscol.education.fr/1681/programmes-et-ressources-en-enseignement-moral-et-civique-voie-gt',
  },
  geographie2de: {
    status: 'PUBLIC',
    title: 'Géographie-EMC 2<sup>de</sup>',
    subtitle: 'Géographie 2de',
    isbn: '9782958353919',
    price: '8,50€',
    programUrl: 'https://eduscol.education.fr/1681/programmes-et-ressources-en-enseignement-moral-et-civique-voie-gt',
  },
  histoiregeographie2de: {
    status: 'PUBLIC',
    title: 'Histoire-Géographie-EMC 2<sup>de</sup>',
    subtitle: 'Histoire/Géographie/EMC 2de',
    isbn: '9782958353926',
    price: '12,50€',
    programUrl: 'https://eduscol.education.fr/1681/programmes-et-ressources-en-enseignement-moral-et-civique-voie-gt',
  },
  histoire1ere: {
    status: 'PUBLIC',
    title: 'Histoire-EMC 1<sup>ere</sup>',
    subtitle: 'Histoire 1ère',
    isbn: '9782958353933',
    price: '8,50€',
    programUrl: 'https://eduscol.education.fr/1681/programmes-et-ressources-en-enseignement-moral-et-civique-voie-gt',
  },
  geographie1ere: {
    status: 'PUBLIC',
    title: 'Géographie-EMC 1<sup>ere</sup>',
    subtitle: 'Géographie 1ère',
    isbn: '9782958353940',
    price: '8,50€',
    programUrl: 'https://eduscol.education.fr/1681/programmes-et-ressources-en-enseignement-moral-et-civique-voie-gt',
  },
  histoiregeographie1ere: {
    status: 'PUBLIC',
    title: 'Histoire-Géographie-EMC 1<sup>ere</sup>',
    subtitle: 'Histoire/Géographie/EMC 1ère',
    isbn: '9782958353957',
    price: '12,50€',
    programUrl: 'https://eduscol.education.fr/1681/programmes-et-ressources-en-enseignement-moral-et-civique-voie-gt',
  },
  histoiregeographiednlanglaisterm: {
    status: 'DRAFTED',
    title: 'Histoire-géographie Terminale DNL anglais section euro',
    subtitle: 'H-G DNL anglais Term',
    isbn: '9791098614927',
  },
  allemand2de: {
    status: 'PUBLIC',
    title: 'Allemand 2<sup>de</sup>',
    subtitle: 'Allemand 2de',
    isbn: '9782958353995',
    price: '8,50€',
    programUrl: 'https://www.education.gouv.fr/bo/2025/Hebdo22/MENE2504621A',
  },
  allemand1ere: {
    status: 'PUBLIC',
    title: 'Allemand 1<sup>ere</sup>',
    subtitle: 'Allemand 1ère',
    isbn: '9782958353971',
    price: '8,50€',
    programUrl: 'https://www.education.gouv.fr/bo/2025/Hebdo22/MENE2504621A',
  },
  allemandterm: {
    status: 'DRAFTED',
    title: 'Allemand Terminale',
    subtitle: 'Allemand Terminale',
    isbn: '9782958353988',
    price: '8,50€',
    programUrl: 'https://www.education.gouv.fr/bo/2025/Hebdo22/MENE2504621A',
  },
  italien2de: {
    status: 'PUBLIC',
    title: 'Italien 2<sup>de</sup>',
    subtitle: 'Italien 2de',
    isbn: '9782958353964',
    price: '8,50€',
    programUrl: 'https://www.education.gouv.fr/bo/2025/Hebdo22/MENE2504621A',
  },
  italien1ere: {
    status: 'DRAFTED',
    title: 'Italien 1<sup>ere</sup>',
    subtitle: 'Italien 1ère',
    isbn: '9791098614903',
    price: '8,50€',
    programUrl: 'https://www.education.gouv.fr/bo/2025/Hebdo22/MENE2504621A',
  },
  italienterm: {
    status: 'PUBLIC',
    title: 'Italien Terminale',
    subtitle: 'Italien Terminale',
    isbn: '9791098614910',
    price: '8,50€',
    programUrl: 'https://www.education.gouv.fr/bo/2025/Hebdo22/MENE2504621A',
  },
};

export default {
  title: "Le premier manuel scolaire numérique qui s'adapte aux élèves",
  description:
    "L'écran du savoir propose les premiers manuels numériques interactifs conçu pour les enseignants qui souhaitent différencier facilement leurs cours et mieux évaluer leurs élèves.",
  name: "Home",
  components: {
    ModalNewsletter,
  },
  props: ["email_contact"],
  data: () => ({
    apiHost,
    manuals: [],
    dialog_newsletter: false,
  }),
  methods: {
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
    openModalNewsletter() {
      this.dialog_newsletter = true;
    },
    closeModalNewsletter() {
      this.dialog_newsletter = false;
    },
    manualItem(slug) {
      const defaults = MANUAL_DEFAULTS[slug] || {};
      const apiManual = this.manuals.find((manual) => manual.slug === slug);

      if (!apiManual) {
        return defaults;
      }

      // On part des valeurs par défaut puis on applique les valeurs de l'API,
      // en ignorant celles qui sont vides afin de conserver les défauts.
      const merged = { ...defaults };
      Object.keys(apiManual).forEach((key) => {
        const value = apiManual[key];
        if (value !== null && value !== '' && value !== undefined) {
          merged[key] = value;
        }
      });

      return merged;
    },
    manualField(slug, field, fallback = '') {
      const manual = this.manualItem(slug);

      if (field === 'subtitle' && manual.status !== 'PUBLIC') {
        return manual.title ?? fallback;
      }

      const value = manual[field];
      return value === null || value === '' || value === undefined ? fallback : value;
    },
    manualConnectUrl(slug) {
      const manual = this.manualItem(slug) || {};
      return manual.status === 'PUBLIC' ? `${this.apiHost}/api/connect_demo_user/${slug}` : null;
    },
    manualButtonLabel(slug) {
      const manual = this.manualItem(slug) || {};
      return manual.status === 'PUBLIC' ? 'Je découvre le manuel' : 'Bientôt disponible le manuel';
    },
    fetchManuals() {
      apiClient
        .get('/api/public/manuals')
        .then((response) => {
          this.manuals = Array.isArray(response.data) ? response.data : [];
        })
        .catch(() => {
          this.manuals = [];
        });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$gtag.event("home", { method: "Google" });
    this.fetchManuals();
  },
};
</script>

<style lang="scss" scoped>
span {
  display: block;
}

// Manuel pas encore disponible : pas de href -> bouton non cliquable.
a.btn-link:not([href]) {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

a.programme:hover {
  text-decoration: underline;
}
.video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 ratio */
  height: 0;
  overflow: hidden;
}
.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.ile-de-france {
  text-align: center;
  line-height: 1.3rem;
  padding: 10px;
  background-color: white;
  border: 3px solid #ed3725;
}

.ile-de-france img {
  margin: 0 auto;
  max-width: 240px;
}
</style>
